export function Skeleton({
  w,
  h,
  className = '',
}: {
  w: number | string;
  h: number | string;
  className?: string;
}) {
  return <div className={`skeleton ${className}`} style={{ width: w, height: h }} />;
}

import { useT } from '../../i18n';

export function FormSkeleton() {
  const t = useT();
  return (
    <div className="flex-1 px-5 flex flex-col">
      <div className="px-[18px] pt-[14px] pb-[18px]" style={{ background: 'var(--t-surface)', borderRadius: 5 }}>
        <Skeleton w={70} h={14} className="mb-3" />
        <div className="flex justify-between items-center">
          <Skeleton w={120} h={32} />
          <Skeleton w={75} h={32} />
        </div>
      </div>
      <div className="px-[18px] pt-[12px] pb-[18px]" style={{ background: 'var(--t-surface)', borderRadius: 5, marginTop: 4 }}>
        <Skeleton w={50} h={14} className="mb-3" />
        <div className="flex justify-between items-center">
          <Skeleton w={180} h={32} />
          <Skeleton w={85} h={32} />
        </div>
      </div>
      <div className="flex justify-between mt-3 px-[2px]">
        <Skeleton w={140} h={12} />
        <Skeleton w={90} h={12} />
      </div>
      <div className="mt-8">
        <Skeleton w={65} h={14} className="mb-2.5" />
        <Skeleton w="100%" h={47} />
      </div>
      <div className="flex-1" />
      <Skeleton w="100%" h={60} className="mb-2" />
      <div className="text-center py-3">
        <span className="text-[11px]" style={{ color: 'var(--t-text-tertiary)' }}>{t('skeleton.poweredBy')}</span>
      </div>
    </div>
  );
}
